
import { computed, defineComponent, PropType, reactive, ref, watch } from 'vue'
import ContentAdaptLayout from '../../../../_components/content-adapt-layout/content-adapt-layout.vue'
import {
  GroupPolicySettingsService,
  GroupPolicyTypes,
  IntervalTypes,
  ExaminationTaskTypes,
  RegularPhysicalExaminationSettings
} from '../../group-policy-settings.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import MixSelectors from '@/views/dashboard/_components/group-policy-settings/_components/mix-selectors/mix-selectors.vue'
import { OperateType } from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.service'
import { BrandConfig, useBrandCustomStore } from '@/services/brand-custom.service'

const DEFAULT_PARAMS = {
  main_switch: true,
  task_type: 0,
  interval_type: 3,
  frequency: 1
}

export default defineComponent({
  components: {
    MixSelectors,
    ContentAdaptLayout
  },
  props: {
    operateType: {
      type: String as PropType<'edit'|'add'|'read'>,
      default: 'edit'
    },
    policyId: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ''
    },
    activeName: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector()
    const groupPolicySettingsService = injector.get(GroupPolicySettingsService)
    const loading = ref<boolean>(true)
    const dialogDemoVisible = ref<boolean>(false)
    const strategy = reactive<RegularPhysicalExaminationSettings>({
      ...DEFAULT_PARAMS
    })
    const data = reactive({
      allExamTip: false,
      hasEdit: false
    })

    const allExamImages: Record<string, string> = {
      'zh-CN': require('../_assets/zh-CN/all_exam.png'),
      'zh-TW': require('../_assets/zh-TW/all_exam.png'),
      'en-US': require('../_assets/en-US/all_exam.png'),
      'ja-JP': require('../_assets/ja-JP/all_exam.png'),
    }
    const threeMinExamImages: Record<string, string> = {
      'zh-CN': require('../_assets/zh-CN/3min_exam.png'),
      'zh-TW': require('../_assets/zh-TW/3min_exam.png'),
      'en-US': require('../_assets/en-US/3min_exam.png'),
      'ja-JP': require('../_assets/ja-JP/3min_exam.png'),
    }

    const allExamImage = computed(() => allExamImages[locale.value] || allExamImages['zh-CN'])
    const threeMinExamImage = computed(() => threeMinExamImages[locale.value] || threeMinExamImages['zh-CN'])
    function getSettings () {
      groupPolicySettingsService.getSettings({
        id: props.policyId,
        type: GroupPolicyTypes.RegularPhysicalExamination
      }).then(response => {
        groupPolicySettingsService.updateSelectors('regularExamSelectors', (response.strategy as RegularPhysicalExaminationSettings).regular_tasks)
        Object.assign(strategy, {
          ...DEFAULT_PARAMS,
        }, response.strategy)
      }).finally(() => {
        loading.value = false
      })
    }

    function saveSettings () {
      groupPolicySettingsService.saveSettings({
        id: props.policyId,
        type: GroupPolicyTypes.RegularPhysicalExamination,
        strategy: JSON.stringify(strategy)
      }).then(() => {
        groupPolicySettingsService.updateEditTab(false)
        context.emit('save')
      })
    }
    function cancel () {
      context.emit('cancel')
    }
    groupPolicySettingsService.regularExamSelectors.subscribe((res: any) => {
      strategy.regular_tasks = res
    })
    groupPolicySettingsService.hasEditTab.subscribe((hasEdit: boolean) => {
      data.hasEdit = hasEdit
    })
    groupPolicySettingsService.saveTab.subscribe((name: string) => {
      if (name === 'regular-physical-examination') {
        saveSettings()
      }
    })
    watch(() => props.activeName, (newV) => {
      if (newV === 'regular-physical-examination') {
        getSettings()
      }
    })
    watch(() => strategy.regular_tasks.length, (length) => {
      if (length > 1) {
        strategy.interval_type = 0
      }
    })
    getSettings()

    return {
      t,
      OperateType,
      brandConfig: useBrandCustomStore().brandConfig as BrandConfig,
      loading,
      strategy,
      ExaminationTaskTypes,
      dialogDemoVisible,
      data,
      allExamImage,
      threeMinExamImage,
      IntervalTypes,
      cancel,
      handlerShowDialogDemo (flag: boolean) {
        data.allExamTip = flag
        dialogDemoVisible.value = true
      },
      handlerSave () {
        saveSettings()
      },
      setChangeStatus () {
        groupPolicySettingsService.updateEditTab(true)
      },
      changeFrequency () {
        groupPolicySettingsService.updateEditTab(true)
        groupPolicySettingsService.updateSelectors('regularExamSelectors', [{ target: 1, start_min: 0, end_min: 10 }])
      }
    }
  }
})
